const FindDetails = () => {
    return (
        <div>
            <p>Find and Replace Document Details</p>
        </div>
    )
}

export default FindDetails